import React from 'react';
import { FormControlWrapper } from './FormGroup.styles.js'; // eslint-disable-next-line no-empty-pattern

function FormGroup(_a) {
  var children = _a.children,
      justifyContent = _a.justifyContent;
  return React.createElement(FormControlWrapper, {
    justifyContent: justifyContent
  }, children);
}

export { FormGroup };